import React from "react";
import {
  Card,
  Button,
  Form,
  CardTitle,
  CardText,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import Reform from "@franleplant/reform";
import classNames from "classnames";
import { serviceCaller, ServiceCallerProps } from "../../../Admin/composition";
import { executeForgotPassword } from "../../../utils/fetch";
import { RouterProps, withRouter } from "../../../utils/withRouter";

interface Props extends ServiceCallerProps, RouterProps {}

interface State {
  fields: {
    email: string;
  };
  isLoading: boolean;
  forgotError: boolean;
  responseMessage: string;
}

class ForgotPassword extends React.Component<Props, State> {
  re = Reform.reactMixins.objectMixin(this);

  state = {
    fields: {
      email: "",
    },
    errors: {},
    isLoading: false,
    forgotError: false,
    responseMessage: null,
  };

  validationRules = {
    email: { email: true, required: true },
  };

  validationMessages = {
    required: _ => `Required`,
    email: _ => `Must be a valid email`,
    minLength: ruleValue => `Must be at least ${ruleValue} characters long`,
    default: _ => `Invalid`,
  };

  onChangeFactory = fieldName => {
    return event => {
      const value = event.target.value;
      this.setState(state => {
        const fields = {
          ...state.fields,
          [fieldName]: value,
        };

        return { ...state, error: {}, fields };
      });
    };
  };

  onSubmit = e => {
    e.preventDefault();
    const isValid = this.re.validateFormFromState();
    if (!isValid) {
      this.setState({
        responseMessage: null,
      });
      return;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        executeForgotPassword(
          this.props.config.authServiceUrl,
          this.state.fields
        )
          .then(response =>
            this.setState({
              responseMessage: response,
              isLoading: false,
            })
          )
          .catch(error =>
            this.setState({
              responseMessage: error.message || "Something went wrong. Please try again.",
              isLoading: false,
            })
          );
      }
    );
  };

  render() {
    return (
      <div className={s.popup}>
        <Card body className={s.roundedCorners}>
          <CardTitle>
            <p className={s.title}>Reset Your Password</p>
          </CardTitle>
          <br />
          <CardText className={s.text}>
            Don't worry. We'll email you
            <br />
            instructions to reset your password.
          </CardText>
          <Form className={s.paddingForm}>
            <FormGroup>
              <Label for="email" className={s.label}>
                Email
              </Label>
              <Input
                type="email"
                name="User Name"
                id="userEmail"
                value={this.state.fields.email}
                onChange={this.onChangeFactory("email")}
                className={classNames(s.textField, s.roundedCorners)}
              />
            </FormGroup>
            <ul>
              {this.re.mapFieldErrors("email").map((message, index) => {
                return (
                  <li key={index} className={s.error}>
                    {message}
                  </li>
                );
              })}
            </ul>
            <div className={s.centerDiv}>
              {this.state.responseMessage && (
                <div className={s.message}>
                  <Label className={s.requestMessage}>
                    {this.state.responseMessage}
                  </Label>
                </div>
              )}
              <Button
                id={"resetPasswordButton"}
                onClick={this.onSubmit}
                className={classNames(s.button, s.roundedCorners)}
                disabled={this.state.isLoading}
                color={"none"}
              >
                Reset Password
              </Button>
            </div>
          </Form>
        </Card>
        <br />
        <div className={s.centerDiv}>
          <Button
            id={"returnToSignIn"}
            color="link"
            className={s.link}
            onClick={() => this.props.navigate("/")}
          >
            Return to Sign In
          </Button>
        </div>
      </div>
    );
  }
}

export default serviceCaller(withStyles(s)(withRouter(ForgotPassword)));
